import * as React from 'react';
import TableBody from '@material-ui/core/TableBody';

const CustomTableBody = (props) => {
    return <TableBody {...props} />;
};

export { CustomTableBody as TableBody };
